import i18n from "@app/translations/i18n";
import {
  FALLBACK_LANGUAGE,
  SUPPORTED_LANGUAGES,
  TSupportedLanguages,
} from "@app/translations/i18n.interfaces";
import logger from "@app/utils/logger";
import { Settings } from "luxon";

export const setLuxonLocale = (language: TSupportedLanguages) => {
  Settings.defaultLocale = SUPPORTED_LANGUAGES.includes(language)
    ? language
    : FALLBACK_LANGUAGE;
};

const changeLanguage = (language: TSupportedLanguages) => {
  i18n.changeLanguage(language);
  setLuxonLocale(language);
};

i18n.on("languageChanged", (lng: TSupportedLanguages) => {
  logger.info("Language changed to", lng);
  setLuxonLocale(lng);
});

export default changeLanguage;
